import React from 'react';
import { GenericError } from './GenericFormError.styles';
import {} from './GenericFormError.types';
const GenericFormError = ({ errorMessage, children }) => (React.createElement(GenericError, null,
    errorMessage,
    children));
export default GenericFormError;
